import ElInput from './src/input';

/* istanbul ignore next */
ElInput.install = function(Vue) {
  Vue.component(ElInput.name, ElInput);
};

export default ElInput;



// WEBPACK FOOTER //
// ./~/element-ui/packages/input/index.js